import type { GraphApiResponse, GraphPeriod } from './types'

export type FetchGraphDataOptions = {
    apiUrl: string
    headers?: Record<string, string>
    period?: GraphPeriod
    signal?: AbortSignal
}

function withQuery(url: string, params: Record<string, string | undefined>): string {
    const entries = Object.entries(params).filter(([, value]) => value != null && value !== '')
    if (entries.length === 0) return url

    const query = entries
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
        .join('&')

    if (url.includes('?')) {
        if (url.endsWith('?') || url.endsWith('&')) return `${url}${query}`
        return `${url}&${query}`
    }
    return `${url}?${query}`
}

export async function fetchGraphData(options: FetchGraphDataOptions): Promise<GraphApiResponse> {
    const { apiUrl, headers, period, signal } = options

    const requestInit: RequestInit = { signal }
    if (headers && Object.keys(headers).length > 0) {
        requestInit.headers = headers
    }

    const url = withQuery(apiUrl, { period })
    const res = await fetch(url, requestInit)
    if (!res.ok) throw new Error(`HTTP ${res.status}`)
    return (await res.json()) as GraphApiResponse
}
